import React from 'react';
import { Box } from '@chakra-ui/react';
import { useTokens } from '../../../context/TokenProvider';
const PhotoBox = ({ children, boxSize = 100, ...rest }) => {
    const tokens = useTokens();
    return (React.createElement(Box, { ...rest, borderColor: tokens.CanvasPrimary, borderWidth: tokens.BorderWidth01, boxSize: boxSize, borderRadius: tokens.BorderRadius02, position: "relative" }, children));
};
export default PhotoBox;
